import React from 'react';

export default class Systems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };
  }

  getCurrentClass = index => {
    const { currentSystem, invalidList, validList } = this.props;

    if (index === +currentSystem.index) return 'active';
    if (invalidList[index]) return 'invalid';
    if (validList[index]) return 'valid';
    return '';
  };

  getSelectedElements = () => {
    const { boatSystems, handleSystemDelete } = this.props;

    let selectedSystemsBannersList = boatSystems.map((system, index) => {
      return (
        <div
          key={'system' + index}
          className={`boat-systems-scene__banner ${this.getCurrentClass(index)}`}
          onClick={this.handleSystemChoose(index)}
        >
          <div
            className={`boat-systems-scene__banner-icon boat-systems-scene__banner-icon_type_${system.componentSystemId}`}
          />
          <div className='boat-systems-scene__banner-text'>{system.name}</div>
          <div className='boat-systems-scene__banner-delete-button' onClick={handleSystemDelete(index)} />
          <div className='boat-systems-scene__banner-valid-label' />
        </div>
      );
    });

    selectedSystemsBannersList.push(<div className='boat-systems-scene__banners-delimiter' />);

    return selectedSystemsBannersList.length > 1 ? selectedSystemsBannersList : null;
  };

  getAvailableSystemsBanners = () => {
    const { isOpen } = this.state;
    const { boatSystems, allSystemsList } = this.props;

    return allSystemsList
      .filter(
        system =>
          boatSystems.filter(boatSystem => system.id === boatSystem.componentSystemId).length < system.maxQuantity
      )
      .map((system, index) => {
        const openIconLeftShift = (index + 1) * 70;
        const nameSliceIndex = system.name.search(/\([^0-9]+/);
        const name = nameSliceIndex !== -1 ? system.name.slice(0, nameSliceIndex) : system.name;
        return (
          <div
            key={system.id}
            className='boat-systems-scene__banner'
            onClick={this.handleSystemAdd(system)}
            style={{ left: isOpen ? 0 : -openIconLeftShift }}
          >
            <div className={`boat-systems-scene__banner-icon boat-systems-scene__banner-icon_type_${system.id}`} />
            <div className='boat-systems-scene__banner-text'>{name}</div>
          </div>
        );
      });
  };

  handleSystemAdd = system => () => {
    const { handleSystemAdd } = this.props;
    handleSystemAdd(system);
    this.toggleSystems();
  };

  handleSystemChoose = system => () => {
    const { handleSystemChoose } = this.props;
    handleSystemChoose(system);
  };

  toggleSystems = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { invalidList } = this.props;
    const addSystemBannersList = this.getAvailableSystemsBanners();

    return (
      <section className='scene_section boat-systems-scene__banners-section'>
        <header>Boat Systems</header>

        {Object.keys(invalidList).length ? (
          <div className='boat-systems-scene__banners-section-error-text'>
            If the Component System is added, all required Components must be filled *
          </div>
        ) : null}

        <div className='boat-systems-scene__banners-wrapper'>
          {this.getSelectedElements()}

          {!!addSystemBannersList.length && (
            <div className='_flex'>
              <div
                className='boat-systems-scene__banner add-system _z_index_10 _background_color_white'
                onClick={this.toggleSystems}
              >
                <div className='boat-systems-scene__banner-icon'>+</div>
                <div className='boat-systems-scene__banner-text'>Add System</div>
              </div>
              {addSystemBannersList}
            </div>
          )}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/AddComponents/Systems.jsx